import React, { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Button, Card } from "antd";
import { chosenFranchise } from "./useFranchiseChoice";
import BannerForm from "./BannerForm";
import { HiddenTag, WindowTags } from "./bannerTags";
import HomeBannersLayout from "./HomeBannersLayout";
import PhonePreview from "./PhonePreview";
import SectionBanners from "./SectionBanners";
import SectionTrail from "./SectionTrail";
import useSectionPage from "./useSectionPage";

const SectionTitle = ({ section }) => (
  <span className="d-flex align-items-center" style={{ gap: 12 }}>
    <img src={section.logo} alt="" style={{ width: 40, height: 40, objectFit: "cover", borderRadius: 8 }} />
    {section.title}
    <WindowTags section={section} />
    <HiddenTag reason={section.hidden_now} />
  </span>
);

export default function BannerSection() {
  const { id } = useParams();
  const location = useLocation();
  const franchiseId = chosenFranchise(new URLSearchParams(location.search));
  const { section, banners, placement, franchise, version, load } = useSectionPage(id, franchiseId);
  const [editing, setEditing] = useState(null);

  if (!section) return <HomeBannersLayout />;
  return (
    <HomeBannersLayout>
      <SectionTrail placement={placement} section={section} franchiseId={franchiseId} />
      <div className="row">
        <div className="col-xl-8 col-lg-7">
          <Card title={<SectionTitle section={section} />} extra={<Button type="primary" onClick={() => setEditing({})}>Add banner</Button>}>
            <SectionBanners banners={banners} onChanged={load} onEdit={(banner) => setEditing({ row: banner })} />
          </Card>
        </div>
        <div className="col-xl-4 col-lg-5">
          <PhonePreview franchise={franchise} screen={placement.screen} highlightPlacement={placement.id} version={version} />
        </div>
      </div>
      <BannerForm
        open={Boolean(editing)}
        banner={editing && editing.row}
        placement={section.placement}
        sectionId={section.id}
        franchiseId={franchiseId}
        onClose={() => setEditing(null)}
        onSaved={() => {
          setEditing(null);
          load();
        }}
      />
    </HomeBannersLayout>
  );
}
